<template>
  <modal
    :show.sync="scouterEstimate.show"
    class="modal-primary"
    :show-close="false"
    header-classes="justify-content-center"
    type="mini"
  >
    <div
      slot="header"
      class="ml-4"
    >
      <h6><i class="ti ti-receipt mr-2" /><span class="text-danger">Update Participant & Staff Estimates</span></h6>
    </div>
    <ValidationObserver ref="scouterEstimateForm">
      <form @submit.prevent="saveScouterEstimate">
        <ValidationProvider
          name="participants"
          rules="required|max_value:56|min_value:24"
          v-slot="{ passed, failed }"
        >
          <div class="row">
            <label class="col-md-9 col-form-label">Estimated Participants</label>
            <div class="col-md-3">
              <fg-input
                name="participants"
                title="Estimated Participant Count"
                type="number"
                :has-success="passed"
                min="24"
                max="56"
                v-model="scouterEstimate.participants"
              />
            </div>
            <div
              class="col-md-12"
              style="color:#ef8157;font-size:80%;margin-top:0.25rem"
              v-if="failed"
            >
              {{ failed ? 'A number between 24 and 56 is required.': null }}
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          name="staff"
          rules="required|max_value:30|min_value:5"
          v-slot="{ passed, failed }"
        >
          <div class="row mt-3">
            <label class="col-md-9 col-form-label">Estimated Staff Members</label>
            <div class="col-md-3">
              <fg-input
                name="staff"
                title="Estimated Staff Count"
                :has-success="passed"
                type="number"
                min="5"
                max="30"
                v-model="scouterEstimate.staff"
              />
            </div>
            <div
              class="col-md-12"
              style="color:#ef8157;font-size:80%;margin-top:0.25rem"
              v-if="failed"
            >
              {{ failed ? 'A number between 5 and 30 is required.': null }}
            </div>
          </div>
        </ValidationProvider>
      </form>
    </ValidationObserver>
    <template slot="footer">
      <p-button
        type="danger"
        class="mr-2"
        @click="scouterEstimate.show = false"
      >
        Cancel
      </p-button>
      <p-button
        type="success"
        class="mr-2"
        @click="saveScouterEstimate"
      >
        Save
      </p-button>
    </template>
  </modal>
</template>

<script>
import budgetApi from '@/services/api/budget.js'
import Modal from '@/plugins/paper-components/modal.vue'
// eslint-disable-next-line camelcase
import { max_value, min_value } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

extend('max_value', max_value)
extend('min_value', min_value)

export default {
  name: 'ScouterEstimatesModal',
  components: {
    Modal
  },
  props: {
    scouterEstimate: {
      type: Object,
      default: function () {
        return {}
      }
    },
    budgetId: {
      type: Number,
      default: null
    }
  },
  methods: {
    saveScouterEstimate: function () {
      return this.$refs.scouterEstimateForm.validate().then(res => {
        if (res) {
          const budgetUpdate = {
            Id: this.budgetId,
            CourseKey: this.$root.courseKey,
            EstimatedStaff: this.scouterEstimate.staff,
            EstimatedParticipants: this.scouterEstimate.participants
          }

          budgetApi.updateBudget(budgetUpdate)
            .then(x => {
              this.$emit('budget-info-refreshed', x)
            })
            .catch(error => {
              console.log(error)
              this.$notify({
                message: 'There was an error updating the budget info.',
                icon: 'bi bi-exclamation-circle-fill',
                type: 'error',
                horizontalAlign: 'center',
                timeout: 2000
              })
            })
            .finally(() => {
              this.scouterEstimate.show = false
            })
        }
        return res
      })
    }
  }
}
</script>
